import { SPXAPI } from '../interfaces';
import { BASEURL, ENDPOINTS } from '../endpoints';

// Reuses the same `/files/multiple_link` endpoint that the owner-side Share flow
// uses. We pass the caller's own email as `recipient_identity` so the BE mints
// the same recipient-scoped link the user already received in their share email.
//
// Forwardability is governed entirely by server-side policy (`allowForwarding` /
// `allowForwardingInDomain`), not by the link itself: when the policy permits
// forwarding, a third party who receives the URL can re-authenticate and gain
// access; when it does not, the link remains bound to the original recipient.
// So this is functionally equivalent to the recipient forwarding their own
// share email — same link, same policy enforcement.
const getRecipientShareLink = async (
    API: SPXAPI,
    fileId: string,
    recipientEmail: string,
): Promise<string | null> => {
    try {
        const result = await API.post(
            BASEURL.backend(),
            ENDPOINTS.createMultipleFilesLink(),
            {
                body: {
                    files_ids: [fileId],
                    recipient_identity: recipientEmail,
                    recipient_type: 'user',
                },
            },
        );
        return result?.link ?? null;
    } catch {
        return null;
    }
};

export default getRecipientShareLink;
